<template>
    <v-container fluid class="mt-0 pt-0">
        <v-row>
            <v-col>
                <v-btn v-if="!processingPdfGenerate" @click="savePDF" large color="primary" class="pt-0 mt-0" style="display: block;"><v-icon class="pr-2">print</v-icon> {{ year }}. {{ month }}. Nyomtatás </v-btn>
                <v-alert v-else type="info">PDF dokumentum generálása folyamatban...</v-alert>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import download from 'downloadjs'
    export default {
        name: "UserDetailPrint",

        data () {
            return {
                processingPdfGenerate: false
            }
        },

        props: {
            year: { required: true },
            month: { required: true },
            userId: { required: true },
        },

        methods: {
            async savePDF() {
                this.processingPdfGenerate = true

                await this.$axios({ url: `/user-montly-pdf/${this.userId}/${this.year}/${this.month}`, method: 'GET' })
                    .then(resp => {
                        download(`data:application/pdf;base64,${resp.data.pdf}`, `${this.year}-${this.month}-havi-munkaorak.pdf` )
                    })

                this.processingPdfGenerate = false
            }
        }
    }
</script>

<style scoped>

</style>
